import i18n from "../../../utils/i18n";

/**
 * Industry select card display data — order follows `industryInput1()` in searchFlowText.js.
 * Titles, emojis and subtitles match the Version B wireframe.
 */
export const INDUSTRY_SELECT_META = {
  etrade: {
    title: i18n.t("industrylabels.etrade"),
    emoji: "🛒",
    subtitle: i18n.t("searchflow.subtitleetrade"),
  },
  IT: {
    title: i18n.t("industrylabels.IT"),
    emoji: "👩‍💻",
    subtitle: i18n.t("searchflow.subtitleit"),
  },
  construction: {
    title: i18n.t("industrylabels.construction"),
    emoji: "🧱",
    subtitle: i18n.t("searchflow.subtitleconstruction"),
  },
  courier: {
    title: i18n.t("industrylabels.courier"),
    emoji: "🚚",
    subtitle: i18n.t("searchflow.subtitlecourier"),
  },
  retail: {
    title: i18n.t("industrylabels.retail"),
    emoji: "🛍️",
    subtitle: i18n.t("searchflow.subtitleretail"),
  },
  wholesale: {
    title: i18n.t("industrylabels.wholesale"),
    emoji: "🚚",
    subtitle: i18n.t("searchflow.subtitlewholesale"),
  },
  art: {
    title: i18n.t("industrylabels.art"),
    emoji: "🎨",
    subtitle: i18n.t("searchflow.subtitleart"),
  },
  beauty: {
    title: i18n.t("industrylabels.beauty"),
    emoji: "💅",
    subtitle: i18n.t("searchflow.subtitlebeauty"),
  },
  sport: {
    title: i18n.t("industrylabels.sport"),
    emoji: "⚽",
    subtitle: i18n.t("searchflow.subtitlesport"),
  },
  education: {
    title: i18n.t("industrylabels.education"),
    emoji: "📚",
    subtitle: i18n.t("searchflow.subtitleeducation"),
  },
  logistics: {
    title: i18n.t("industrylabels.logistics"),
    emoji: "📦",
    subtitle: i18n.t("searchflow.subtitlelogistics"),
  },
  medicine: {
    title: i18n.t("industrylabels.medicine"),
    emoji: "❤️",
    subtitle: i18n.t("searchflow.subtitlemedicine"),
  },
  travel: {
    title: i18n.t("industrylabels.travel"),
    emoji: "🍽️",
    subtitle: i18n.t("searchflow.subtitletravel"),
  },
  manufacturing: {
    title: i18n.t("industrylabels.manufacturing"),
    emoji: "🥩",
    subtitle: i18n.t("searchflow.subtitlemanufacturing"),
  },
  finance: {
    title: i18n.t("industrylabels.finance"),
    emoji: "💰",
    subtitle: i18n.t("searchflow.subtitlefinance"),
  },
  agriculture: {
    title: i18n.t("industrylabels.agriculture"),
    emoji: "👨‍🌾",
    subtitle: i18n.t("searchflow.subtitleagriculture"),
  },
  startup: {
    title: i18n.t("industrylabels.startup"),
    emoji: "✨",
    subtitle: i18n.t("searchflow.subtitlestartup"),
  },
  vehicle: {
    title: i18n.t("industrylabels.vehicle"),
    emoji: "🚗",
    subtitle: i18n.t("searchflow.subtitlevehicle"),
  },
  realestate: {
    title: i18n.t("industrylabels.realestate"),
    emoji: "🏡",
    subtitle: i18n.t("searchflow.subtitlerealestate"),
  },
  lawyer: {
    title: i18n.t("industrylabels.lawyer"),
    emoji: "🧑‍⚖️",
    subtitle: i18n.t("searchflow.subtitlelawyer"),
  },
  engineer: {
    title: i18n.t("industrylabels.engineer"),
    emoji: "🛠️",
    subtitle: i18n.t("searchflow.subtitleengineer"),
  },
  otherservices: {
    title: i18n.t("industrylabels.otherservices"),
    emoji: "💬",
    subtitle: i18n.t("searchflow.subtitleotherservices"),
  },
  consultancy: {
    title: i18n.t("industrylabels.consultancy"),
    emoji: "🤝",
    subtitle: i18n.t("searchflow.subtitleconsultancy"),
  },
  other: {
    title: i18n.t("industrylabels.other"),
    emoji: "💬",
    subtitle: "",
  },
};

/** Keys in `industryInput1()` order — single source for render order. */
export const INDUSTRY_SELECT_ORDER = [
  "etrade",
  "IT",
  "construction",
  "courier",
  "retail",
  "wholesale",
  "art",
  "beauty",
  "sport",
  "education",
  "logistics",
  "medicine",
  "travel",
  "manufacturing",
  "finance",
  "agriculture",
  "startup",
  "vehicle",
  "realestate",
  "lawyer",
  "engineer",
  "otherservices",
  "consultancy",
  "other",
];

export const getIndustrySelectMeta = (value) =>
  INDUSTRY_SELECT_META[value] || {
    title: value,
    emoji: "💼",
    subtitle: "",
  };
